export default {"src":"/_next/static/media/adapt.cd285749.svg","height":92,"width":108};